export enum BookingStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  ADVANCE_PAID = "ADVANCE_PAID",
  FULLY_PAID = "FULLY_PAID",
  CANCELLING = "CANCELLING",
  CANCELED = "CANCELED"
}